export default __webpack_public_path__ + "static/media/Draig-Regular.c0e3698f.otf";